// Import React for building the UI components
import React from 'react';

// Import ReactDOM for rendering the components in the browser's DOM
import ReactDOM from 'react-dom/client';

// Import the main App component
import App from './App';

// Import the Redux store for state management
import { store } from "./redux/store";

// Import the Provider component from react-redux to wrap the application and provide the store to child components
import { Provider } from "react-redux";

// Create a root using ReactDOM.createRoot() and pass the DOM element with the ID 'store-app' as the target
const root = ReactDOM.createRoot(document.getElementById('store-app'));

// If the root is successfully created, render the App component wrapped in the Provider component
if (root) {
    root.render(
        // Provide the Redux store to the application using the Provider component
        <Provider store={store}>
            <App />
        </Provider>
    );
}